import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-133885a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "layout-menuitem-root-text"
}
const _hoisted_2 = ["href", "target"]
const _hoisted_3 = { class: "layout-menuitem-text" }
const _hoisted_4 = { class: "layout-menuitem-text" }
const _hoisted_5 = { class: "layout-submenu" }

export function render(_ctx, _cache) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_router_link = _resolveComponent("router-link")
  const _component_app_sidebar_menu_item = _resolveComponent("app-sidebar-menu-item")

  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass({ 'layout-root-menuitem': _ctx.root, 'active-menuitem': _ctx.isActiveMenu })
  }, [
    (_ctx.root && _ctx.item.visible !== false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.item.label), 1))
      : _createCommentVNode("", true),
    ((!_ctx.item.to || _ctx.item.items) && _ctx.item.visible !== false)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: _ctx.item.url,
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.itemClick($event, _ctx.item, _ctx.index))),
          class: _normalizeClass(_ctx.item.class),
          target: _ctx.item.target,
          tabindex: "0"
        }, [
          (Array.isArray(_ctx.item.icon) && _ctx.item.icon.length === 2 && _ctx.item.icon.every(i => typeof i === 'string' && i.trim() !== ''))
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                icon: _ctx.item.icon,
                class: "layout-menuitem-icon"
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.item.label), 1),
          (_ctx.item.items)
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 1,
                icon: ['fas', 'chevron-down'],
                class: "layout-submenu-toggler"
              }))
            : _createCommentVNode("", true)
        ], 10, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.item.to && !_ctx.item.items && _ctx.item.visible !== false)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 2,
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.itemClick($event, _ctx.item, _ctx.index))),
          class: _normalizeClass([_ctx.item.class, { 'active-route': _ctx.checkActiveRoute(_ctx.item) }]),
          tabindex: "0",
          to: _ctx.item.to
        }, {
          default: _withCtx(() => [
            (Array.isArray(_ctx.item.icon) && _ctx.item.icon.length === 2 && _ctx.item.icon.every(i => typeof i === 'string' && i.trim() !== ''))
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 0,
                  icon: _ctx.item.icon,
                  class: "layout-menuitem-icon"
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.item.label), 1),
            (_ctx.item.items)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 1,
                  icon: ['fas', 'chevron-down'],
                  class: "layout-submenu-toggler"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class", "to"]))
      : _createCommentVNode("", true),
    (_ctx.item.items && _ctx.item.visible !== false)
      ? (_openBlock(), _createBlock(_Transition, {
          key: 3,
          name: "layout-submenu"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("ul", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.items, (child, i) => {
                return (_openBlock(), _createBlock(_component_app_sidebar_menu_item, {
                  key: child,
                  index: i,
                  item: child,
                  parentItemKey: _ctx.itemKey,
                  root: false
                }, null, 8, ["index", "item", "parentItemKey"]))
              }), 128))
            ], 512), [
              [_vShow, _ctx.root ? true : _ctx.isActiveMenu]
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 2))
}